module.exports = __webpack_public_path__ + "static/Mitchell.d8b3ddff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Mitchell.jpg
// module id = 1316
// module chunks = 137408898365125